import { API_LOGIN, API_LOGOUT } from "../../utils/api/ApiConstant";
import { defaultAxios } from "../../utils/api/axios";
import showToast from "../../utils/toastUtil";
import { userAction } from "./user-slice";
import { uiActions } from "../ui/ui-slice";
import { decryptPayload, encryptPayload } from "../../helper/common";
import { getAxios, postAxios } from "../../Services/commonService";

export const loginUser = async (dispatch, payload) => {
  try {
    dispatch(uiActions.setLoading(true));
    // const { password } = payload;
    // const encryptedPass = encryptPayload(password);
    // const body = {
    //   ...payload,
    //   password,
    // };
    const data = await postAxios({ url: API_LOGIN, payload });
    if (data) {
      dispatch(userAction.setToken(data?.accessToken));
      dispatch(userAction.updateUser(data?.user));
    }
    dispatch(uiActions.setLoading(false));
  } catch (err) {
    dispatch(uiActions.setLoading(false));
  }
};

export const logoutUser = async (dispatch) => {
  try {
    await postAxios({ url: API_LOGOUT, payload: {} });
    await dispatch(userAction.clearUser());
  } catch (error) {
    // showToast.error(error?.data?.message);
  }
};

let isLogoutInProgress = false; // Prevent multiple logout calls

export const handleAxiosError = async (error, dispatch, token) => {
  // Handle network errors
  if (error?.message === "Network Error") {
    if (!isLogoutInProgress) {
      isLogoutInProgress = true; // Set the flag
      try {
        if (token && token !== "") {
          await logoutUser(dispatch); // Call logout function
        }
      } catch (logoutError) {
        console.error("Logout error:", logoutError);
        showToast.error("Error logging out. Please try again.");
      } finally {
        // isLogoutInProgress = false; // Reset the flag
      }
    }
  }

  // Handle other types of errors (e.g., 401 Unauthorized)
  if (error?.response?.status === 401) {
    try {
      // if (token && token !== "") {
      //   await logoutUser(dispatch);
      // }
      await dispatch(userAction.clearUser());
      showToast.error("Session expired.");
    } catch (logoutError) {
      console.error("Logout error:", logoutError);
    }
  }

  // Return a rejected promise to allow further error handling
  return Promise.reject(error);
};
